import { render, staticRenderFns } from "./ShiftSetupEdit.vue?vue&type=template&id=ff30bc6c"
import script from "./ShiftSetupEdit.vue?vue&type=script&lang=js"
export * from "./ShiftSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports